import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { labQKeys } from "@hooks/queries/lab/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  lab: FormData;
  labId: string;
  patientId: string;
}

export const useUpdateLab = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ lab, labId }: MutationProps) => {
      return api.patch(`lab/${labId}`, lab, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "update-lab-success",
      });
      queryClient.invalidateQueries({
        queryKey: labQKeys.patient(variables.patientId),
      });
    },

    onError: res => {
      console.error("[From Update Lab]", res);

      handleErrors(res, "mutation");
    },
  });
};
